import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideBrowserWarning, hideCertWarning } from 'actions/ui';
import styles from 'styles/modules/certWarningBar.module.scss';

const CertWarningBar = () => {
	const certWarnings = useSelector(state => state.ui.certWarnings);
	const browserWarning = useSelector(state => state.ui.browserWarning);
	const dispatch = useDispatch();

	if ((!certWarnings || certWarnings.length === 0) && !browserWarning) {
		return null;
	}

	return (
		<div className={styles.certWarningBar}>
			{browserWarning && (
				<>
					<div className={styles.header}>
						<span className={styles.title}>Застаріла версія браузера</span>
						<span className={styles.text}>
							Для стабільної роботи CRM оновіть
							{` ${browserWarning.browserName} ${browserWarning.currentVersion || ''} `}
							до останньої версії. Якщо не оновити браузер, частина функціоналу може працювати
							некоректно або бути недоступною.
						</span>
					</div>
					<div className={styles.list}>
						<div className={styles.item} key="browserWarning">
							<span className={styles.domain}>{browserWarning.browserName}</span>
							<a
								className={styles.link}
								href={browserWarning.updateUrl}
								target="_blank"
								rel="noopener noreferrer"
							>
								Оновити браузер
							</a>
							<button
								type="button"
								className={styles.dismiss}
								onClick={() => dispatch(hideBrowserWarning())}
							>
								Приховати
							</button>
						</div>
					</div>
				</>
			)}

			{certWarnings && certWarnings.length > 0 && (
				<>
					<div className={styles.header}>
						<span className={styles.title}>Потрібно підтвердити сертифікат</span>
						<span className={styles.text}>
							Відкрийте посилання у новій вкладці та підтвердьте сертифікат, щоб запити працювали.
						</span>
					</div>

					<div className={styles.list}>
						{certWarnings.map((item) => {
							const href = item.url || `https://${item.domain}`;

							return (
								<div className={styles.item} key={item.domain}>
									<span className={styles.domain}>{item.domain}</span>
									<a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">
										Відкрити
									</a>
									<button
										type="button"
										className={styles.dismiss}
										onClick={() => dispatch(hideCertWarning(item.domain))}
									>
										Приховати
									</button>
								</div>
							);
						})}
					</div>
				</>
			)}
		</div>
	);
};

export default CertWarningBar;
